import React from 'react';

interface DebugPanelProps {
  showDebug: boolean;
  setShowDebug: (value: boolean) => void;
  threadId: string | null;
  sessionId: string | null;
  debugSessionId: string | null; // Session ID from URL params for debugging
  handleClearCache: () => void;
}

/**
 * Renders the debug panel with session information and controls.
 */
export const DebugPanel: React.FC<DebugPanelProps> = ({
  showDebug,
  setShowDebug,
  threadId,
  sessionId,
  debugSessionId,
  handleClearCache,
}) => {
  if (!showDebug) {
    return null;
  }

  return (
    <div className="border-t border-gray-300 p-4 bg-gray-100 text-xs">
      <div className="flex justify-between mb-2">
        <h3 className="font-semibold">Debug Panel</h3>
        <button 
          onClick={() => setShowDebug(false)}
          className="text-red-500 hover:text-red-700"
        >
          Close
        </button>
      </div>
      
      <div className="grid grid-cols-2 gap-2">
        <div>Thread ID: {threadId || 'None'}</div>
        {/* Show session ID from store first, fallback to debug param */}
        <div>Session ID: {sessionId || debugSessionId || 'None'}</div>
      </div>
      
      <div className="mt-2 flex space-x-2">
        <button
          onClick={handleClearCache}
          className="px-2 py-1 bg-red-500 text-white text-xs rounded hover:bg-red-700"
        >
          Clear Cache
        </button>
      </div>
    </div>
  );
}; 